import clsx from 'clsx';

export const WORD_DURATION = 450;
export const STAGGER = 90;

export type Phase = 'entering' | 'holding' | 'exiting';

type Props = {
  className?: string;
  phrases: string[];
  index?: number;
  phase?: Phase;
};

export function normalizePhrases(phrases: string[]) {
  return (phrases ?? [])
    .map((item) => (typeof item === 'string' ? item : ''))
    .map((item) => item.trim())
    .filter(Boolean);
}

export function TitleAnimationServer({ className, phrases, index = 0, phase = 'holding' }: Props) {
  const words = normalizePhrases(phrases)[index]?.split(' ') ?? [];

  return (
    <div className="flex items-start gap-3" data-animation>
      {words.map((word, i) => {
        const delay = i * STAGGER;

        return (
          <div
            key={`${index}-${i}`}
            className={clsx('overflow-hidden h-[52.8px]', className)}
            data-animation-item
          >
            <span
              style={
                phase !== 'holding'
                  ? {
                      display: 'block',
                      animationName: phase === 'entering' ? 'title-slide-in' : 'title-slide-out',
                      animationDuration: `${WORD_DURATION}ms`,
                      animationDelay: `${delay}ms`,
                      animationTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)',
                      animationFillMode: 'both',
                    }
                  : { display: 'block' }
              }
              className="pr-2"
            >
              {word}
            </span>
          </div>
        );
      })}
    </div>
  );
}

export default TitleAnimationServer;
